(function () {
    'use strict';

    var app = angular.module('app');

    app.filter('time', function () {

        var conversions = {
            'ss': angular.identity,
            'mm': function (value) { return value * 60; },
            'hh': function (value) { return value * 3600; }
        };

        var padding = function (value, length) {
            var zeroes = length - ('' + (value)).length,
                pad = '';
            while (zeroes-- > 0) pad += '0';
            return pad + value;
        };

        return function (value, unit, format, isPadded) {
            var totalSeconds = conversions[unit || 'ss'](value),
                hh = Math.floor(totalSeconds / 3600),
                mm = Math.floor((totalSeconds % 3600) / 60),
                ss = totalSeconds % 60;

            format = format || 'hh:mm';
            isPadded = angular.isDefined(isPadded) ? isPadded : true;
            hh = isPadded ? padding(hh, 2) : hh;
            mm = isPadded ? padding(mm, 2) : mm;

            return format.replace(/hh/, hh).replace(/mm/, mm);
        };
    });

    app.filter('floatToString', function () {
        return function (value) {
            if (!value)
                return '';

            var s = String(value).replace('.', ',');
            return s;
        };
    });

    app.filter('dateFromValues', function () {
        return function (day, month, year) {
            if (!day || !month || !year)
                return '';

            var sDay = String(day), sMonth = String(month), sYear = String(year);
            var pad = "00"
            sDay = pad.substring(0, pad.length - sDay.length) + sDay;
            sMonth = pad.substring(0, pad.length - sMonth.length) + sMonth;
            sYear = pad.substring(0, pad.length - sYear.length) + sYear;

            return sDay + '/' + sMonth + '/' + sYear;
        };
    });

    app.filter('dayOfWeek', function () {
        return function (value) {            
            if (!value || value == undefined)
                return "";

            var retVal = "";

            switch (value) {
                case 0:
                    retVal = "Luned&igrave;";
                    break;
                case 1:
                    retVal = "Marted&igrave;";
                    break;
                case 2:
                    retVal = "Mercoled&igrave;";
                    break;
                case 3:
                    retVal = "Gioved&igrave;";
                    break;
                case 4:
                    retVal = "Venerd&igrave;";
                    break;
                case 5:
                    retVal = "Sabato";
                    break;
                case 6:
                    retVal = "Domenica";
                    break;
                default:
                    retVal = "";
                    break;
            }

            return retVal;
        };
    });

    app.filter('dateToMyFormat', function ($filter) {
        return function (value) {
            if (!value || value.length === 0)
                return "";

            var retVal = "";
            var date = new Date(value);
            var day = value.getDay();
            value = $filter('date')(value, 'dd/MM/yyyy');

            switch (day) {
                case 0:
                    retVal = "Lun " + value;
                    break;
                case 1:
                    retVal = "Mar " + value;
                    break;
                case 2:
                    retVal = "Mer " + value;
                    break;
                case 3:
                    retVal = "Gio " + value;
                    break;
                case 4:
                    retVal = "Ven " + value;
                    break;
                case 5:
                    retVal = "Sab " + value;
                    break;
                case 6:
                    retVal = "Dom " + value;
                    break;
                default:
                    retVal = "";
                    break;
            }

            return retVal;
        };
    });

    app.filter('teamRole', function () {
        return function (value) {
            if (!value || value == '')
                return '';

            if (value.toUpperCase().trim() == 'L')
                return '<span class="fa-role"><i class="fa fa-user-circle blue"></i> Leader</span>';

            if (value.toUpperCase().trim() == 'M')
                return '<span class="fa-role"><i class="fa fa-user grey"></i> Membro</span>';

            return '';
        }
    });

    app.filter('dipAttivo', function () {
        return function (value) {
            if (value == undefined)
                return '';
            
            if (value == true)
                return '<span class="label label-success label-rd"> attivo</span>';
            else if(value == false)            
                return '<span class="label label-warning label-rd">non attivo</span>';

            return '';
        }
    });

    //*************************************************************
    /* Direttive create per verifica del funzionamento e dell'inclusione     */
    //*************************************************************    
    app.directive('ccImageLoader', function () {
        var directive = {};

        directive.restrict = 'E'; /* restrict this directive to elements */
        directive.transclude = true;
        directive.templateUrl = "/app/html-templates/loader.html";

        return directive;
    });
    //*************************************************************

    app.directive('typeaheadCheckId', function () {
        //Usage:
        //Controlla che l'oggetto abbia una prorpietà Id
        var directive = {
            require: 'ngModel',
            link: link
        }
        return directive;

        function link(scope, elm, attrs, ctrl) {

            function validate(value) {
                var isValid = false;

                if (value == null) {
                    return false;
                }

                if (value.Id) {
                    isValid = true;
                }

                ctrl.$setValidity('typeaheadCheckId', isValid);
                return isValid;
            }

            scope.$watch(function () {
                return ctrl.$modelValue;
            }, validate);
        }
    });

    app.directive('ccImgPerson', ['config', function (config) {
        //Usage:
        //<img data-cc-img-person="{{s.speaker.imageSource}}"/>
        var basePath = config.imageSettings.imageBasePath;
        var unknownImage = config.imageSettings.unknownPersonImageSource;
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$observe('ccImgPerson', function (value) {
                value = basePath + (value || unknownImage);
                attrs.$set('src', value);
            });
        }
    }]);

    app.directive('ccSidebar', function () {
        // Opens and clsoes the sidebar menu.
        // Usage:
        //  <div data-cc-sidebar>
        // Creates:
        //  <div data-cc-sidebar class="sidebar">
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var $sidebarInner = element.find('.sidebar-inner');
            var $dropdownElement = element.find('.sidebar-dropdown a');
            element.addClass('sidebar');
            $dropdownElement.click(dropdown);

            function dropdown(e) {
                var dropClass = 'dropy';
                e.preventDefault();
                if (!$dropdownElement.hasClass(dropClass)) {
                    hideAllSidebars();
                    $sidebarInner.slideDown(350);
                    $dropdownElement.addClass(dropClass);
                } else if ($dropdownElement.hasClass(dropClass)) {
                    $dropdownElement.removeClass(dropClass);
                    $sidebarInner.slideUp(350);
                }

                function hideAllSidebars() {
                    $sidebarInner.slideUp(350);
                    $('.sidebar-dropdown a').removeClass(dropClass);
                }
            }
        }
    });

    app.directive('ccWidgetClose', function () {
        // Usage:
        // <a data-cc-widget-close></a>
        // Creates:
        // <a data-cc-widget-close="" href="#" class="wclose">
        //     <i class="fa fa-remove"></i>
        // </a>
        var directive = {
            link: link,
            template: '<i class="fa fa-remove"></i>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$set('href', '#');
            attrs.$set('wclose');
            element.click(close);

            function close(e) {
                e.preventDefault();
                element.parent().parent().parent().hide(100);
            }
        }
    });

    app.directive('ccWidgetMinimize', function () {
        // Usage:
        // <a data-cc-widget-minimize></a>
        // Creates:
        // <a data-cc-widget-minimize="" href="#"><i class="fa fa-chevron-up"></i></a>
        var directive = {
            link: link,
            template: '<i class="fa fa-chevron-up"></i>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            //$('body').on('click', '.widget .wminimize', minimize);
            attrs.$set('href', '#');
            attrs.$set('wminimize');
            element.click(minimize);

            function minimize(e) {
                e.preventDefault();
                var $wcontent = element.parent().parent().next('.widget-content');
                var iElement = element.children('i');
                if ($wcontent.is(':visible')) {
                    iElement.removeClass('fa fa-chevron-up');
                    iElement.addClass('fa fa-chevron-down');
                } else {
                    iElement.removeClass('fa fa-chevron-down');
                    iElement.addClass('fa fa-chevron-up');
                }
                $wcontent.toggle(500);
            }
        }
    });

    app.directive('ccScrollToTop', ['$window', function ($window) {
        // Usage:
        // <span data-cc-scroll-to-top></span>
        // Creates:
        // <span data-cc-scroll-to-top="" class="totop">
        //      <a href="#"><i class="fa fa-chevron-up"></i></a>
        // </span>
        var directive = {
            link: link,
            template: '<a href="#"><i class="fa fa-chevron-up"></i></a>',
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            var $win = $($window);
            element.addClass('totop');
            $win.scroll(toggleIcon);

            element.find('a').click(function (e) {
                e.preventDefault();
                // Learning Point: $anchorScroll works, but no animation
                //$anchorScroll();
                $('body').animate({ scrollTop: 0 }, 500);
            });

            function toggleIcon() {
                $win.scrollTop() > 300 ? element.slideDown() : element.slideUp();
            }
        }
    }]);

    app.directive('ccSpinner', ['$window', function ($window) {
        // Description:
        //  Creates a new Spinner and sets its options
        // Usage:
        //  <div data-cc-spinner="vm.spinnerOptions"></div>
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.spinner = null;
            scope.$watch(attrs.ccSpinner, function (options) {
                if (scope.spinner) {
                    scope.spinner.stop();
                }
                scope.spinner = new $window.Spinner(options);
                scope.spinner.spin(element[0]);
            }, true);
        }
    }]);

    app.directive('ccWidgetHeader', function () {
        //Usage:
        //<div data-cc-widget-header title="vm.map.title"></div>
        var directive = {
            link: link,
            scope: {
                'title': '@',
                'subtitle': '@',
                'rightText': '@',
                'allowCollapse': '@'
            },
            templateUrl: '/app/layout/widgetheader.html',
            restrict: 'A',
        };
        return directive;

        function link(scope, element, attrs) {
            attrs.$set('class', 'widget-head');
        }
    });

    //*************************************************************
    /* Direttiva per just gage                                   */
    /* I nomi devono essere in minuscolo                         */
    //*************************************************************
    app.directive('justgage',
        function () {
            return {
                restrict: 'EAC',
                scope: {
                    title: '@',                       // gauge title text
                    titlefontcolor: '@',              // title text color

                    value: '@',                       // value to show
                    valuefontcolor: '@',              // color of value text

                    width: '@',                       // gauge width
                    height: '@',                      // gauge height
                    relativegaugesize: '@',           // true if the gauge has to grow with the container

                    min: '@',                         // minimum value
                    max: '@',                         // maximum value

                    valueminfontsize: '@',            // absolute minimum font size for the value
                    titleminfontsize: '@',            // absolute minimum font size for the title
                    labelminfontsize: '@',            // absolute minimum font size for the label
                    minlabelminfontsize: '@',         // absolute minimum font size for the minimum label
                    maxlabelminfontsize: '@',         // absolute minimum font size for the maximum label

                    hidevalue: '@',                   // hide value text
                    hideminmax: '@',                  // hide min and max values
                    hideinnershadow: '@',             // hide inner shadow

                    gaugewidthscale: '@',             // width of the gauge element
                    gaugecolor: '@',                  // background color of gauge element

                    showinnershadow: '@',             // true to display inner shadow
                    shadowopacity: '@',               // shadow opacity, values 0 ~ 1
                    shadowsize: '@',                  // inner shadow size
                    shadowverticaloffset: '@',        // how much is shadow offset from top

                    levelcolors: '@',                 // array of strings, colors of indicator, from lower to upper, in hex format
                    customsectors: '@',               // Array of objects with color, hi, lo attributes
                    nogradient: '@',                  // true to use sector-based color change, false to use gradual color change

                    label: '@',                       // text to show below value
                    labelfontcolor: '@',              // color of label under the value

                    startanimationtTime: '@',          // length of initial load animation
                    startanimationtype: '@',          // type of initial animation (linear, >, <, <>, bounce)
                    refreshanimationtime: '@',        // length of refresh animation
                    refreshanimationtype: '@',        // type of refresh animation (linear, >, <, <>, bounce)

                    donut: '@',                       // Turn the gauge into a full circle donut
                    donutstartangle: '@',             // angle to start from when in donut mode

                    counter: '@',                     // Increase numbers one by one
                    decimals: '@',                    // Quantity of decimal numbers to show
                    symbol: '@',                      // Unit of measure that will be appended to value
                    formatnumber: '@',                // Whether to format numbers
                    humanfriendly: '@',               // true to show shorthand big numbers (300K instead of 300XXX)
                    humanfriendlydecimal: '@',        // number of decimal places for our human friendly number to contain

                    textrenderer: '&'                 // function applied before rendering text
                },
                controller: 'justgageCtrl',
                link: function (scope, element, attrs, justgageCtrl) {
                    var justgage,
                        watchers = [];

                    /**
                     * Bind the `value` property on the scope in order to refresh the JustGage when it changes.
                     */
                    var bindValue = function () {
                        watchers.push(scope.$watch('value', function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                justgage.refresh(newValue, scope.max);
                            }
                        }));
                        watchers.push(scope.$watch('max', function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                justgage.refresh(scope.value, newValue);
                            }
                        }));
                    };

                    /**
                     * Bind all scope paramenters other than `value` and `textRenderer` and re-creates the JustGage whenever
                     * one of them changes.
                     */
                    var bindOtherOptions = function () {
                        var otherOptionsNames = justgageCtrl.getOptionsNames(['value', 'max']);
                        // TODO: move to angularjs 1.3 and replace with $watchGroup
                        angular.forEach(otherOptionsNames, function (name) {
                            watchers.push(scope.$watch(name, function (newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    init();
                                }
                            }));
                        });
                    };

                    /**
                     * Initialize the JustGage element with the given non-undefined options on the scope.
                     * It also binds the scope values to appropriate changes
                     */
                    var init = function () {
                        var justgageOptions = {
                            parentNode: element[0]
                        };
                        angular.extend(justgageOptions, justgageCtrl.getDefinedOptions());

                        // Remove existing canvas from DOM (if any)
                        if (justgage) {
                            var canvasDom = justgage.canvas.canvas;
                            canvasDom.parentNode.removeChild(canvasDom);
                        }

                        // Clear existing watcher (see http://stackoverflow.com/a/17306971 why while & pop)
                        while (watchers.length > 0) {
                            var watcher = watchers.pop();
                            watcher();
                        }

                        // rebuild the gage
                        //console.dir(justgageOptions);
                        justgage = new JustGage(justgageOptions);

                        // Bind scope changes to element methods
                        bindValue();
                        bindOtherOptions();
                    };

                    // Initialize everything on the next $digest cycle
                    init();
                }
            };
        });

    //*************************************************************
    /* Direttive Progress Bar     */
    //*************************************************************
    app.directive('progressbar', function () {
        return {
            restrict: 'C',
            scope: {
                valuecurrent: '@',
                valuemax: '@',
            },
            link: function (scope, element, attrs) {
                scope.warning = parseInt(scope.valuecurrent) > parseInt(scope.valuemax);
            },
            templateUrl: '/app/html-templates/progress.html'
        }
    });
    app.directive('progressbarperc', function () {
        return {
            restrict: 'C',
            scope: {
                valuecurrent: '@',
                valuemax: '@',
            },
            link: function (scope, element, attrs) {
                scope.warning = parseInt(scope.valuecurrent) > parseInt(scope.valuemax);
            },
            templateUrl: '/app/html-templates/progressPerc.html'
        }
    });

    //*************************************************************
    /* Direttive create per gestire il messaggio di conferma "salvataggio dati" prima della navigazione in altre pagine     */
    //*************************************************************
    angular.module('app').directive('formInit', function () {
        return {
            restrict: 'A',
            scope: {
                init: '&formInit'
            },
            controller: function ($scope, $element) {
                var name = null;
                if ($element[0] && $element[0].name) {
                    name = $element[0].name;
                }

                var listener = $scope.$watch('init', function () {
                    if ($scope[name] && $scope.init) {
                        $scope.init();
                        listener();
                    }
                });
            }
        };
    });

    //*************************************************************
    /* Direttive create per gestire il messaggio di conferma "salvataggio dati" prima della navigazione in altre pagine     */
    //*************************************************************
    angular.module('app').directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        };
    }]);

    angular.module('app').directive('clickme', function () {
        return function (scope, element, attrs) {
            var clickingCallback = function () {
                $("#image_file").trigger('click');
            };
            element.bind('click', clickingCallback);
        };
    });

    app.filter('groupRecord', function (_) {
        function groupBy(array, f) {
            var groups = {};
            array.forEach(function (o) {
                var group = JSON.stringify(f(o));
                groups[group] = groups[group] || [];
                groups[group].push(o);
            });
            return Object.keys(groups).map(function (group) {
                return groups[group];
            });
        }

        return function (value) {
            if (!value || value.length == 0)
                return '';

            if (value.length > 0) {
                var tipologie = '';
                if (value[0].AreaTecnicaId == 0 || !value[0].AreaTecnicaId) {
                    value.forEach(function (item, i, array) {
                        if (i === array.length - 1)
                            tipologie += item.TestoAltro;
                        else
                            tipologie += item.TestoAltro + ', ';
                    });
                } else {
                    var result = groupBy(value, function (a) {
                        return a.AreaTecnicaId;
                    });

                    result.forEach(function (res) {
                        res.forEach(function (r, index, arr) {
                            if (index === 0 && r.AreaTecnica)
                                tipologie += r.AreaTecnica + ': ';
                            if (index === arr.length - 1)
                                tipologie += r.TestoAltro + ' ';
                            else if (r.AreaTecnica)
                                tipologie += r.TestoAltro + ', ';
                            else
                                tipologie += r.TestoAltro + '; ';
                        });
                    });
                }

                return tipologie;
            }
        };
    });
})();